import { storyblokEditable, renderRichText } from "@storyblok/react"
import { motion } from "framer-motion"

const item = {
  hidden: { opacity: 0, y: 24, filter: "blur(4px)" },
  show: {
    opacity: 1,
    y: 0,
    filter: "blur(0px)",
    transition: { duration: 0.5, ease: "easeOut" },
  },
}

export default function TierItem({ blok }: any) {
  const stripText = (rich: any) =>
    renderRichText(rich || { content: [] })
      ?.toString()
      .replace(/<[^>]+>/g, "")
      .trim()

  const isHighlighted = !!blok.highlighted

  const wrapperClasses = isHighlighted
    ? "relative rounded-3xl p-[2px] bg-gradient-to-br from-[#4750F5] to-[#8BA3FF] shadow-[0_18px_50px_rgba(71,80,245,0.22)]"
    : "relative rounded-3xl p-[2px] bg-transparent"

  const cardClasses =
    "flex flex-col h-full rounded-3xl bg-white border border-gray-200 px-7 py-8 shadow-sm"

  return (
    <motion.div
      variants={item}
      whileHover={{ y: -6, scale: isHighlighted ? 1.02 : 1.01 }}
      transition={{ type: "spring", stiffness: 300, damping: 22 }}
      className="relative"
    >
      {isHighlighted && (
        <div className="absolute -top-4 left-1/2 -translate-x-1/2 z-20">
          <span className="inline-block bg-gradient-to-r from-[#4750F5] to-[#8BA3FF] text-white text-xs font-semibold px-3 py-1 rounded-full shadow-md">
            Most Popular
          </span>
        </div>
      )}

      <div className={wrapperClasses}>
        <div {...storyblokEditable(blok)} className={cardClasses}>
          <div
            className={`font-['BeausiteClassic'] font-bold text-xl md:text-2xl text-gray-900 mb-1 ${
              isHighlighted ? "tracking-tight" : ""
            }`}
            dangerouslySetInnerHTML={{
              __html: renderRichText(blok.title || { content: [] }) || "",
            }}
          />

          <div className="flex items-end justify-between gap-3 mb-5">
            <div
              className="text-sm md:text-base text-gray-600"
              dangerouslySetInnerHTML={{
                __html: renderRichText(blok.subtitle || { content: [] }) || "",
              }}
            />
            <p className="text-base md:text-lg font-semibold text-gray-900 whitespace-nowrap">
              {blok.discountedPrice
                ? `${stripText(blok.discountedPrice)}`
                : `${stripText(blok.price) || "—"}`}
              {blok.discountedPrice && (
                <span className="line-through text-sm text-gray-400 ml-2">
                  {stripText(blok.price)}
                </span>
              )}
            </p>
          </div>

          <div
            className="text-base md:text-[17px] text-gray-700 leading-relaxed mb-5"
            dangerouslySetInnerHTML={{
              __html: renderRichText(blok.summary || { content: [] }) || "",
            }}
          />

          <div
            className="text-sm md:text-[15px] text-gray-700 leading-relaxed mt-auto [&_ul]:list-disc [&_ul]:pl-5 [&_li]:mb-1.5"
            dangerouslySetInnerHTML={{
              __html: renderRichText(blok.features || { content: [] }) || "",
            }}
          />
        </div>
      </div>
    </motion.div>
  )
}
